module.exports = __webpack_public_path__ + "static/a-xx-112-art-fab179f32275325fa5f766e8c4f5998f.jpg";